import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ownedListFilter } from './ownedListFilter';

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [ownedListFilter],
});
